import axios from 'axios';
import crypto from '../utils/crypto';
const baseURL = process.env.VUE_APP_API_BASE_URL;

// 创建 axios 实例
const request = axios.create({
  baseURL: baseURL,
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
  }
});

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 打印请求信息（开发环境）
    if (process.env.VUE_APP_DEBUG === 'true') {
      console.log('发送请求:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL,
        fullURL: (config.baseURL || '') + config.url,
        data: config.data,
        headers: config.headers
      });
    }

    // 可以在这里添加 token 等认证信息
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    if (config.data&&config.isECB !== false) {
        var str = JSON.stringify(config.data)
        config.data = { data: crypto.encryptECB(str) }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    const { data } = response;
    // 打印响应信息（开发环境）
    if (process.env.VUE_APP_DEBUG === 'true') {
      console.log('收到响应:', {
        url: response.config.url,
        status: response.status,
        data: data
      });
    }
    return data;
  },
  error => {
    console.error('请求错误:', error);

    // 处理不同的错误状态
    if (error.response) {
      const { status } = error.response;
      switch (status) {
        case 400:
          console.error('请求参数错误');
          break;
        case 401:
          console.error('未授权，请重新登录');
          break;
        case 403:
          console.error('拒绝访问');
          break;
        case 404:
          console.error('请求地址不存在');
          break;
        case 500:
          console.error('服务器内部错误');
          break;
        default:
          console.error('网络错误');
      }
    } else if (error.request) {
      console.error('网络连接失败');
    } else {
      console.error('请求配置错误');
    }

    return Promise.reject(error);
  }
);

export default request;